
<mat-sidenav-container style="background-color:#eee">
  <mat-sidenav #sideNav [mode]="sidenavMode" [(opened)]="globalVar.menuShow" style="background-color:#111111">
    <div style="padding:10px;text-align:center;">
      <img src="../../../assets/backgroundImgs/無敵雲服務白.png" style="width:100%;margin:1px;vertical-align:middle;" />
   
    </div>
    <div style="color:#fff;border-top:1px solid #333;border-bottom:1px solid #333;padding:10px;min-height:80px">
      <div *ngIf="globalVar.loggedIn">
        <div style="display:inline-block;width:50%;vertical-align:top;text-align:center">
          <img src="{{globalVar.targetIp}}/Upload/{{globalVar.mine.picture}}" style="width:90%" />
          <br />
          <span *ngIf="globalVar.mine">{{globalVar.mine.id}}&nbsp;{{globalVar.mine.name}}</span>
        </div>
        <div style="display:inline-block;width:50%;vertical-align:top;text-align:right">
          <button routerLink="/changePwd" mat-stroked-button style="border: 1px solid #aaa; margin: 2px; width: 80%">修改密碼</button>
          <br />
          <button (click)="logout()" mat-stroked-button style="border: 1px solid #aaa; margin: 2px; width: 80%">登出</button>
        </div>       
      </div>
      <div *ngIf="!globalVar.loggedIn">
        <div style="display:inline-block;width:50%;vertical-align:top;text-align:center">
          <img src="../../../assets/btnImgs/預設大頭貼.png" style="width:90%" />
          <br />
          <span>未登入</span>
        </div>
        <div style="display:inline-block;width:50%;vertical-align:top;text-align:right">
          <button routerLink="/register" mat-stroked-button style="border: 1px solid #aaa; margin: 2px; width: 80%">註冊</button>
          <br />
          <button routerLink="/login" mat-stroked-button style="border: 1px solid #aaa; margin: 2px; width: 80%">登入</button>
        </div>      
      </div>
      </div>

    <mat-accordion multi="true" displayMode="flat">
      <mat-expansion-panel expanded="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span><img src="/assets/btnImgs/側邊欄_課程管理.png" style="height:20px;vertical-align:middle" />&nbsp;&nbsp;<span style="display:inline-block;vertical-align:middle">課程管理</span></span>
          </mat-panel-title>
          <mat-panel-description></mat-panel-description>
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/class/room" routerLinkActive="active1"><img /> 教室</a>
          <a mat-list-item routerLink="/class/material" routerLinkActive="active1"><img /> 教材</a>
          <a mat-list-item routerLink="/class/course" routerLinkActive="active1"><img /> 課程列表</a>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel expanded="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span><img src="/assets/btnImgs/側邊欄_教師管理.png" style="height: 20px; vertical-align: middle" />&nbsp;&nbsp;<span style="display:inline-block;vertical-align:middle">教師管理</span> </span>
          </mat-panel-title>
          <mat-panel-description></mat-panel-description>
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/teacher/profile" routerLinkActive="active1"><img /> 教師列表</a>
          <a mat-list-item routerLink="/teacher/invite" routerLinkActive="active1"><img /> 招聘系統</a>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel expanded="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span><img src="/assets/btnImgs/側邊欄_學生管理.png" style="height: 20px; vertical-align: middle" />&nbsp;&nbsp;<span style="display:inline-block;vertical-align:middle">學生管理</span> </span>
          </mat-panel-title>
          <mat-panel-description></mat-panel-description>
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/student/label" routerLinkActive="active1"><img /> 班級</a>
          <a mat-list-item routerLink="/student/profile" routerLinkActive="active1"><img /> 學生列表</a>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel expanded="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span><img src="/assets/btnImgs/web(20).png" style="height: 20px; vertical-align: middle" />&nbsp;<span style="display:inline-block;vertical-align:middle;margin-left:3px">系統管理</span></span>
          </mat-panel-title>
          <mat-panel-description></mat-panel-description>
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a mat-list-item routerLink="/member" routerLinkActive="active1"><img /> 使用者列表</a>
          <a mat-list-item routerLink="/banner" routerLinkActive="active1"><img /> 輪播圖</a>
        </mat-nav-list>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-sidenav>
  <mat-sidenav-content>
    <span style="float:left">
      <button id="menubtn" style="height:28px;border:0;padding:0;margin:5px 10px;background-color:transparent" (click)="toggleSideNav(sideNav)" matTooltip="{{ globalVar.menuShow ? '關閉選單' : '開啟選單'}}">
        <mat-icon>menu</mat-icon>
      </button>
    </span>
    <app-breadcrumb></app-breadcrumb>
    <div *ngIf="globalVar.progressBar" style="text-align:center">
      <br />
      <img style="height:170px" src="/assets/gifImgs/loading2.gif" />
    </div>
    <!--<mat-progress-bar *ngIf="globalVar.progressBar" mode="indeterminate"></mat-progress-bar>-->
    <div [style.padding]="globalVar.mzPadding" style="min-height:calc(100vh - 50px);border-top:1px #ddd groove " [style.visibility]="globalVar.progressBar ? 'hidden':'visible'">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>


<!--<div class="float-button" [style.left]="sideNav.opened? '260px':'0px' ">
  <button style="opacity:0.5;" mat-fab color="primary" (click)="toggleSideNav(sideNav)" matTooltip="{{ globalVar.menuShow ? '關閉選單' : '開啟選單'}}">
    <img style="width:50px" src="../../../assets/btnImgs/iconfinder_icon-145-tag-cord_314739.png" />
  </button>
</div>-->
<!--<div class="float-button">
  <button style="opacity:0.3;background-color:#000000" mat-fab (click)="toggleSideNav(sideNav)" matTooltip="{{ globalVar.menuShow ? '關閉選單' : '開啟選單'}}">
    <mat-icon>menu</mat-icon>
  </button>
</div>-->
